import React, { useCallback } from "react";
import NavItem from "views/components/sidebar/NavItem";
import useViewsDispatch from "views/stores/useViewsDispatch";
import useViewsSelector from "views/stores/useViewsSelector";
import { selectUndoRedoAvailability } from "views/logic/slices/undoRedoSelectors";
import { undo } from "views/logic/slices/undoRedoActions";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import useHotkey from "hooks/useHotkey";
import useViewType from "views/hooks/useViewType";
const TITLE = "Undo";
const UndoNavItem = ({ sidebarIsPinned }) => {
  const viewType = useViewType();
  const dispatch = useViewsDispatch();
  const { isUndoAvailable } = useViewsSelector(selectUndoRedoAvailability);
  const sendTelemetry = useSendTelemetry();
  const onClick = useCallback(() => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_SIDEBAR_UNDO, {
      app_action_value: "search-sidebar-undo"
    });
    return dispatch(undo());
  }, [dispatch, sendTelemetry]);
  useHotkey({
    actionKey: "undo",
    callback: () => dispatch(undo()),
    scope: viewType.toLowerCase()
  });
  return /* @__PURE__ */ React.createElement(
    NavItem,
    {
      disabled: !isUndoAvailable,
      onClick,
      icon: "undo",
      title: TITLE,
      ariaLabel: TITLE,
      sidebarIsPinned
    }
  );
};
export default UndoNavItem;
